/** A value as JSON, so `null`, `false` and `""` stay distinguishable. */
export function formatValue(value: unknown): string {
  return value === undefined ? '—' : JSON.stringify(value);
}

/** JSON with object keys sorted, so reordering keys is not a change. */
function stableJson(value: unknown): string {
  return JSON.stringify(value, (_key, v: unknown) =>
    v && typeof v === 'object' && !Array.isArray(v)
      ? Object.fromEntries(
          Object.entries(v as Record<string, unknown>).sort(([a], [b]) =>
            a < b ? -1 : a > b ? 1 : 0
          )
        )
      : v
  );
}

/** Fields of `after` whose value differs from `before`'s, compared as JSON. */
export function changedFields(
  before: Record<string, unknown>,
  after: Record<string, unknown>
): Record<string, unknown> {
  return Object.fromEntries(
    Object.entries(after).filter(
      ([key, value]) => stableJson(value) !== stableJson(before[key] ?? null)
    )
  );
}
